import {createTheme} from '@mui/material/styles';


export const mainTheme = createTheme({
  palette: {
    primary: {
      light: '#4d9198',
      main: '#4d9198',
      dark: '#4d9198',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff8b42',
      main: '#ff8b42',
      dark: '#ff8b42',
      contrastText: '#fff',
    }
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: "bold",
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "0.8rem",
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          padding: "15px",
        }
      }
    },
  }
});